export default __webpack_public_path__ + "static/media/referrals2.c5c4c9f7.jpeg";